import React, { useEffect, useState } from 'react'

import PhishingContext from 'contexts/PhishingContext'

import { history } from 'service'
import { routes } from 'Routes'

const PhishingProvider = ({ children }) => {
  const [activeStep, setActiveStep] = useState(0)
  const [lastActiveStep, setLastActiveStep] = useState(0)

  const [wantsToAdvanceStep, setWantsToAdvanceStep] = useState(false)
  const [wantsToReturnStep, setWantsToReturnStep] = useState(false)

  const [activeButton, setActiveButton] = useState(true)
  const [showButtons, setShowButtons] = useState(true)

  const [phishing, setPhishing] = useState({})
  const [isReadOnly, setIsReadOnly] = useState(false)

  const handleAdvanceStep = () => setWantsToAdvanceStep(true)
  const handleReturnStep = () => setWantsToReturnStep(true)

  const resetAdvanceStep = () => setWantsToAdvanceStep(false)
  const resetReturnStep = () => setWantsToReturnStep(false)

  const handleNext = () => setActiveStep((prevActiveStep) => prevActiveStep + 1)

  const handleBack = () => {
    if (activeStep === 0) return history.push(routes.phishing.all)
    setActiveStep((prevActiveStep) => prevActiveStep - 1)
  }

  const handleStep = (step) => {
    if (step > lastActiveStep) return
    setActiveStep(step)
  }

  const isCompleted = (step) => lastActiveStep > step

  useEffect(() => {
    if (
      window.location.pathname === '/phishing/new' &&
      history.action === 'POP'
    ) {
      history.replace(routes.phishing.all)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (activeStep > lastActiveStep) {
      setLastActiveStep(activeStep)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeStep])

  return (
    <PhishingContext.Provider
      value={{
        activeButton,
        activeStep,
        handleAdvanceStep,
        handleBack,
        handleNext,
        handleReturnStep,
        handleStep,
        isCompleted,
        isReadOnly,
        phishing,
        resetAdvanceStep,
        setIsReadOnly,
        resetReturnStep,
        setActiveButton,
        setActiveStep,
        setLastActiveStep,
        setPhishing,
        setShowButtons,
        showButtons,
        wantsToAdvanceStep,
        wantsToReturnStep,
      }}
    >
      {children}
    </PhishingContext.Provider>
  )
}

export default PhishingProvider
